module.exports = __webpack_public_path__ + "static/img/silverVip.3d115f1d.png";